// Session storage key for retaining size selection across colour navigation - SG 20260105
const SIZE_STORAGE_KEY = 'ltdSelectedSize';

export class ProductVariants extends HTMLElement {
    constructor() {
        super();
    }

    getVariantsData(reference: any) {        
        const target = reference.querySelector('[type="application/json"]');

        if(target) {
            return JSON.parse(target.textContent as string);
        }
    }

    onVariantSelect(variantId: string, reference: any) {
        const variantsData = this.getVariantsData(reference);
        // const targetVariant = variantsData.find((variant: any) => {
        //     return variantId == variant.id
        // })

        variantsData.forEach((variant: any) => {
            if (variantId == variant.id) {
                this.updateProductPrice(variant, reference);
                this.updateUrl(variant, reference);
                this.removeErrorMessage(variant, reference);
                // Store selected size for cross-product retention - SG 20260105
                this.storeSelectedSize(variant.title);
            }
        })
    }

    // Store selected size in sessionStorage for retention across colour navigation - SG 20260105
    storeSelectedSize(sizeTitle: string) {
        try {
            sessionStorage.setItem(SIZE_STORAGE_KEY, sizeTitle);
        } catch (e) {
            // Graceful fallback if sessionStorage is blocked
            console.warn('Unable to store size selection:', e);
        }
    }

    // Get stored size from sessionStorage - SG 20260105
    static getStoredSize(): string | null {
        try {
            return sessionStorage.getItem(SIZE_STORAGE_KEY);
        } catch (e) {
            return null;
        }
    }

    // SG 20260115 - Fixed to match Liquid template HTML structure (product-price-pdp.liquid)
    // Previously used BEM classes (product-price__sale) which broke styling after variant selection
    updateProductPrice(variantObject: any, reference: any) {
        const price = (variantObject.price / 100).toFixed(2);
        const salePrice = variantObject.compare_at_price / 100 === 0 ? 0 : (variantObject.compare_at_price / 100).toFixed(2);

        const priceContainer = reference.querySelector("product-price");

        // Get RRP label and currency from data attributes (set by Liquid template)
        const rrpLabel = priceContainer?.dataset.rrpLabel || 'RRP';
        const currency = priceContainer?.dataset.currency || window.currencySymbol || '$';

        // Domains that display RRP label
        const rrpDomains = [
          'lovetodream-au',
          'love-to-dream-uk',
          'lovetodream-eu'
        ];
        const showRrpLabel = rrpDomains.some(domain => Shopify.shop.includes(domain));

        // Build HTML matching Liquid template structure (product-price-pdp.liquid)
        const priceHtml = `
            <product-price class="product-price" data-currency="${currency}" data-rrp-label="${rrpLabel}">
                <div class="text-[24px] md:text-[28px] ${salePrice ? 'text-brand-red' : 'text-brand-teal-dark'}">
                    ${currency}${price}
                </div>
                ${salePrice ? `
                <div class="line-through text-brand-teal-dark">
                    ${currency}${salePrice}
                    ${showRrpLabel ? `<span class="product-price__compare-label">${rrpLabel}</span>` : ''}
                </div>
                ` : ''}
            </product-price>
        `;

        priceContainer.outerHTML = priceHtml;
       
    }

    updateUrl(variantObject: any, reference: any) {
        
    }

    removeErrorMessage(variantObject: any, reference: any) {
        const errorWrappers = reference.querySelectorAll(".product-form__error-message-wrapper");
        errorWrappers.forEach((errorWrapper: any) => {
            const errorMessage = errorWrapper.querySelector(".product-form__error-message");
        
            errorMessage.innerHTML = "";
            errorWrapper.classList.add("hidden");
        })
    }
}
  
customElements.define('product-variants', ProductVariants);
